import React, { useState, useRef, useEffect } from 'react';
import { Typography, TypographyProps, Tooltip } from '@mui/material';

type SparkEllipsisTypographyProps = {
  title?: string;
  children: React.ReactNode;
} & TypographyProps;

function SparkEllipsisTypography({
  children,
  title,
  ...rest
}: SparkEllipsisTypographyProps) {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const typographyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typographyRef.current) {
      setIsOverflowing(
        typographyRef.current.scrollHeight >
          typographyRef.current.clientHeight ||
          typographyRef.current.scrollWidth > typographyRef.current.clientWidth
      );
    }
  }, [children, rest.sx]);

  return (
    <Tooltip
      title={isOverflowing ? title || String(children) : ''}
      sx={{ zIndex: 10000 }}
    >
      <Typography
        ref={typographyRef}
        {...rest}
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          ...rest.sx,
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
}

export default SparkEllipsisTypography;
